import React from "react";
import { Crown } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Alert, AlertDescription, AlertTitle } from "@shadcn-in-nx/ui/alert";

function PlanRestrictionAlert({
    titleKey = "appPreview.upgradeRequired",
    titleFallback = "Upgrade Required",
    descriptionKey,
    descriptionFallback,
    className,
    alertClassName,
    variant = "default", // "default" for border-b style, "inline" for mt-4 style
}) {
    const { t } = useTranslation();

    // Default styling based on variant
    const defaultClassName =
        variant === "inline"
            ? "mt-4 bg-purple-50 border border-purple-200 rounded mb-4"
            : "px-4 py-3 bg-purple-50 border-b border-purple-200";
    const defaultAlertClassName =
        variant === "inline"
            ? "bg-transparent border-0"
            : "bg-transparent border-0 px-4 py-0";

    return (
        <div className={className || defaultClassName}>
            <Alert className={alertClassName || defaultAlertClassName}>
                <Crown className="h-4 w-4 text-purple-600" />
                <AlertTitle className="text-purple-800 text-sm">
                    {t(titleKey) || titleFallback}
                </AlertTitle>
                <AlertDescription className="text-purple-700 text-xs">
                    {descriptionKey
                        ? t(descriptionKey) || descriptionFallback
                        : descriptionFallback}
                </AlertDescription>
            </Alert>
        </div>
    );
}

export default PlanRestrictionAlert;
